import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Configure axios to send cookies with requests
axios.defaults.withCredentials = true;

// Programs API
export const programsAPI = {
  getAll: (params = {}) => axios.get(`${API}/programs`, { params }),
  create: (data) => axios.post(`${API}/programs`, data),
  update: (id, data) => axios.put(`${API}/programs/${id}`, data),
  delete: (id) => axios.delete(`${API}/programs/${id}`),
  archive: (id) => axios.post(`${API}/programs/${id}/archive`),
  restore: (id) => axios.post(`${API}/programs/${id}/restore`),
};

// Athletes API
export const athletesAPI = {
  getAll: (params = {}) => {
    return axios.get(`${API}/athletes`, { params });
  },
  create: (data) => axios.post(`${API}/athletes`, data),
  update: (id, data) => axios.put(`${API}/athletes/${id}`, data),
  delete: (id) => axios.delete(`${API}/athletes/${id}`),
  uploadHeadshot: (athleteId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/upload/headshot/${athleteId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  deleteHeadshot: (athleteId) => axios.delete(`${API}/upload/headshot/${athleteId}`),
  bulkAssign: (athleteIds, programId, action = 'add') =>
    axios.post(`${API}/athletes/bulk-assign`, { athlete_ids: athleteIds, program_id: programId, action }),
};

// Attendance API
export const attendanceAPI = {
  getAll: (filters = {}) => {
    return axios.get(`${API}/attendance`, { params: filters });
  },
  create: (data) => axios.post(`${API}/attendance`, data),
  createBulk: (dataArray) => axios.post(`${API}/attendance/bulk`, dataArray),
  update: (id, data) => axios.put(`${API}/attendance/${id}`, data),
  delete: (id) => axios.delete(`${API}/attendance/${id}`)
};

// Templates API
export const templatesAPI = {
  getAll: () => axios.get(`${API}/templates`),
  create: (data) => axios.post(`${API}/templates`, data),
  createProgram: (templateId, data) => axios.post(`${API}/templates/${templateId}/create-program`, data),
  delete: (id) => axios.delete(`${API}/templates/${id}`),
};

// API Keys API (Enterprise)
export const apiKeysAPI = {
  getAll: () => axios.get(`${API}/api-keys`),
  create: (data) => axios.post(`${API}/api-keys`, data),
  revoke: (id) => axios.delete(`${API}/api-keys/${id}`),
};

// White Label API (Enterprise)
export const whiteLabelAPI = {
  get: () => axios.get(`${API}/white-label`),
  update: (data) => axios.put(`${API}/white-label`, data),
};

// Card Billing API
export const cardBillingAPI = {
  getConfig: () => axios.get(`${API}/billing/config`),
  getQuote: (data) => axios.post(`${API}/billing/quote`, data),
  checkout: (data) => axios.post(`${API}/billing/checkout`, data),
  getPaymentStatus: (orderId) => axios.get(`${API}/billing/payments/${orderId}/status`),
  getCardSubscription: () => axios.get(`${API}/billing/card-subscription`),
  toggleAutoRenew: () => axios.post(`${API}/billing/card-subscription/toggle-auto-renew`),
};

// Card Admin API
export const cardAdminAPI = {
  getOverview: () => axios.get(`${API}/card-admin/overview`),
  getTransactions: (params) => axios.get(`${API}/card-admin/transactions`, { params }),
  getTransaction: (orderId) => axios.get(`${API}/card-admin/transactions/${orderId}`),
  refund: (orderId) => axios.post(`${API}/card-admin/transactions/${orderId}/refund`),
  markReviewed: (orderId, status) => axios.post(`${API}/card-admin/transactions/${orderId}/mark-reviewed`, { status }),
  getSettings: () => axios.get(`${API}/card-admin/settings`),
  updateSettings: (data) => axios.put(`${API}/card-admin/settings`, data),
  testConnection: () => axios.post(`${API}/card-admin/test-connection`),
};
